<template>
  <v-card
    v-if="value"
    :elevation="0"
    :style="{
      border: `1px solid ${$vuetify.theme.primary}`,
      borderLeftWidth: '8px',
      borderRadius: '8px 8px 0 8px'
    }"
  >
    <v-container fluid grid-list-lg class="pa-2" :style="{ width: '100% !important' }">
      <v-layout wrap align-center>
        <v-flex v-if="activeToggleable" :xs12="$vuetify.breakpoint.xsOnly" shrink>
          <v-switch
            :input-value="value.is_active"
            color="primary"
            hide-details
            class="ma-0"
            :loading="isActiveLoading"
            @change="handleActiveChange"
          ></v-switch>
        </v-flex>
        <v-flex :xs12="$vuetify.breakpoint.xsOnly">{{ value.name }}</v-flex>
        <v-flex :xs12="$vuetify.breakpoint.xsOnly" shrink>
          <v-card-actions class="pa-0">
            <v-btn v-if="editable" icon outline small @click="$emit('edit')">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn v-if="deletable" icon outline small color="error" @click="handleDelete">
              <v-icon small>delete</v-icon>
            </v-btn>
            <v-btn
              v-if="sendable"
              icon
              outline
              small
              color="primary"
              :disabled="!userId"
              @click="handleSend"
            >
              <v-icon small>send</v-icon>
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import facebookTemplateApi from '@/api/facebook-template'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    },
    activeToggleable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    sendable: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isActive: this.value && this.value.is_active,
      isActiveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value(value) {
      this.isActive = value.is_active
    }
  },
  methods: {
    async handleActiveChange(value) {
      try {
        this.isActiveLoading = true

        const response = await facebookTemplateApi.put({
          data: {
            id: this.value.id,
            page_id: this.selectedBot.pageid,
            is_active: value
          }
        })

        if (response.status === 204) {
          this.$emit('input', { ...this.value, is_active: value })
        }
      } catch (error) {
        this.$emit('input', { ...this.value })
        console.error(error)
      } finally {
        this.isActiveLoading = false
      }
    },
    async handleDelete() {
      const { value } = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (!value) return

      try {
        this.isLoading = true

        const response = await facebookTemplateApi.delete({
          data: {
            id: this.value.id,
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status === 204) {
          this.$emit('deleted')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async handleSend() {
      this.$emit('sending')

      try {
        const response = await facebookTemplateApi.postSendMessage({
          data: {
            page_id: this.selectedBot.pageid,
            user_id: this.userId,
            name: this.value.name,
            send_type: this.value.send_type,
            message_json: this.value.message_value.map((message) => {
              if (message.type === 'text') {
                return {
                  ...message,
                  text: message.text.replace(
                    /\{\{\d+\}\}/g,
                    (match) =>
                      (this.value.custom_word.find((word) => word.position === match) || {}).text ||
                      ''
                  )
                }
              }
              return message
            })
          }
        })

        if (response.status === 204) {
          this.$emit('sent')
        }
      } catch (error) {
        this.$emit('error:send')
        console.error(error)
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/facebook-template/FacebookTemplateItem.vue